
import vFooter from '../common/footer.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import {
create,
simpleList,
list
} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
Purpose: ['请选择'],
Model: ['请选择'],
gender: '',
isBtn:false,
PurposeArr: [],
ModelArr: [],
isAgree: true,
genders: false,
menus2: {
menu1: '男',
menu2: '女'
},
ModelArrIndex:'',
customerName: '',
customerCompany: '',
customerPhone: '',
customerSex: '',
carCategory: '',
carModel: '',
pid:'',
productId: '',
remark: '',
productList:''
}
},
components: {
vFooter,
Actionsheet,
PopupPicker
},
created() {
this._wxTool.setShare();
if(!this._wxTool.isLogin()){
this.$vux.toast.text('亲，需要先登录哦', 'middle');
this.$router.push('login');
return;
}

this.utils.isAndroid();
this.pid=this.$route.query.productId;
if(this.pid != '' && this.pid != undefined){
this.productId = this.pid;
this.carModel=this.$route.query.productName;
this.carCategory=this.$route.query.categoryName;
this.Purpose = [this.carCategory];
}













let isEmpty = {}
list(isEmpty).then(res => {
if (res.code == 0) {
let productCategoryList = [];
console.log(res);
res.data.productCategoryList.forEach(function(val) {
productCategoryList.push(val.categoryName)
})
this.PurposeArr.push(productCategoryList)
} else {
this.$vux.toast.text(res.msg, 'middle')
}
})

},
methods: {
genderElect() {
this.genders = !this.genders
},
click(key, val) {
console.log(key, val)
this.gender = val
if(this.gender=='男'){
this.customerSex = 1
}else if(this.gender=='女'){
this.customerSex = 2
}

},
remarkChange(){
var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
if(this.remark.match(reg)) {
this.remark = this.remark.replace(reg, '');
}
},

















inputChange(){
if(this.customerName ==''||this.customerPhone==''||this.carCategory == ''){
this.isBtn = false
}else{
this.isBtn = true
}
console.log(this.isBtn)
},
onChange2(val) {//购车意向
console.log('val change', val)
if(val[0]=='请选择'){//插件bug处理
val[0]=this.PurposeArr[0][0]
}
this.Purpose = val
console.log(this.Purpose)
this.carCategory = this.Purpose[0]

this.inputChange();
},
okBtn() {
if(this.customerName == ''){
this.$vux.toast.text('请输入客户姓名','middle')
return
}




if(!this.$TelText(this.customerPhone)){
this.$vux.toast.text('请输入正确的手机号','middle')
return
}




if(this.carCategory == ''||this.carCategory=='请选择'){
this.$vux.toast.text('请选择购车意向','middle')
return
}








let param = {
accessToken : this._wxTool.getAccessToken(),
customerName: this.customerName,
customerCompany: this.customerCompany,
customerPhone: this.customerPhone,
customerSex: this.customerSex,
carCategory: this.carCategory,

productId: this.productId,
remark: this.remark,
}
create(param).then(res => {
if (res.code == 0) {
console.log(res);
this.data = res.data
this.$vux.toast.text('亲，感谢您的推荐，小宇将尽快处理哦', 'middle')

this.customerPhone='';
this.customerName='';
this.$router.push({path:'/'});
} else {
this.$vux.toast.text(res.msg, 'middle')
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/recommend/recommend.vue